import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes.js'
import store from '../store'


Vue.use(Router);

let router = new Router ({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if(nearestWithTitle) {
    if (nearestWithTitle.meta.title.includes("dynamically-create")) {
      var route_path = to.path.split("/");
      var title = "Tassyl"
      for (var i = 1; i < route_path.length; i++) {
        title += " - "
        title += route_path[i].replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function(key) { return key.toUpperCase()})
      }
      document.title = title
    } else {
      document.title = nearestWithTitle.meta.title
    }
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.loginStatus) {
      next()
      return
    }
    store.commit("setAfterLoginPath", to.fullPath)
    next('/login')
  } else {
    next()
  }
})

export default router;



// {
//   path: "/",
//   component: Name,
//   name: ""
//   beforeEnter: (to, from, next) => {
//   // do something
//   },
//   beforeRouteLeave (to, from, next) {
//     const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
//     if (answer) {
//       next()
//     } else {
//       next(false)
//     }
//   }
// }
